import styled, { css } from 'styled-components';

import { beam } from '@styles/colors/themes';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';
import { CurrencyInput } from '@components';

interface IContainer {
  pinnedFields?: boolean;
}

export const Container = styled.div<IContainer>`
  display: flex;
  flex-direction: row;
  justify-content: ${({ pinnedFields }) => pinnedFields && 'flex-end'};
`;

export const Buttons = styled.div<IContainer>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 18px;
  margin-bottom: 10px;
`;

export const Cancel = styled.button`
  color: #474d66;
  font-weight: 500;
  font-size: 14px;
  background: none;
  border: none;
  outline: 0;
`;

export const Done = styled.button`
  color: ${({ disabled }) => (disabled ? '#C1C4D6' : '#1371FE')};
  font-weight: 500;
  font-size: 14px;
  margin-left: 40px;
  margin-right: 16px;
  background: none;
  border: none;
  outline: 0;
`;

interface IContentEditable {
  active?: boolean;
  pinnedFields?: boolean;
}

export const StyledContentEditable = styled.input<IContentEditable>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  white-space: nowrap;
  width: 100%;
  align-content: center;
  align-items: center;
  display: flex;
  height: ${({ pinnedFields }) => (pinnedFields ? '22px' : '32px')};
  color: #474d66;
  font-size: 14px;
  ////
  overflow: hidden;
  text-align: ${({ pinnedFields }) => pinnedFields && 'end'};

  position: relative;
  background: transparent;
  padding-left: 0px;
  padding-right: 0px;
  border: 1px solid transparent;

  ::placeholder {
    color: #c1c4d6;
    opacity: 1;
    font-style: italic;
    padding-right: 1px;
  }

  &:empty:before {
    content: attr(placeholder);
    display: block;
    color: #c1c4d6;
    opacity: 1;
    font-style: italic;
  }

  ${({ active }) =>
    active
      ? css`
          height: 32px;
          background: #fff;
          border-color: #d8dae5;
          border-radius: 4px;
          padding: 4px 8px;
          &[data-error='true'] {
            border-color: ${COLORS_FLAT.r400};
          }
        `
      : css`
          :hover {
            background: ${beam.background.card};
            border-color: ${beam.background.card};
            border-radius: 4px;
            position: unset;
            padding-left: 8px;
            padding-right: 8px;
          }
        `}
`;

export const AssetCurrencyInput = styled(CurrencyInput)`
  .mantine-NumberInput-input {
    min-height: 22px;
    cursor: pointer;
    border-radius: 4px;

    transition-property: padding, background-color;
    transition-duration: 0.1s;
    transition-timing-function: linear;

    &[data-pinned='true'] {
      text-align: end;
    }
    &[data-active='false'] {
      padding: 0px;
      border-width: 0;
    }

    &[data-active='false']:hover {
      padding: 6px 8px;
      background-color: ${beam.background.card};
    }
    &[data-active='true'] {
      padding: 6px 8px;
      border-color: #d8dae5;
    }
    &[data-active='true'][data-error='true'] {
      border-color: ${COLORS_FLAT.r400};
    }
    ::placeholder {
      color: ${COLORS_FLAT.n500};
      opacity: 1;
      font-style: italic;
    }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
